(function() {
  var Communicate, ValidationEngine,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ValidationEngine = App.loadClass('core::ValidationEngine');

  Communicate = App.loadClass('bower::formatter/formatter');

  exports.Communicate_Dialog = (function(superClass) {
    extend(Communicate_Dialog, superClass);

    function Communicate_Dialog() {
      this.populateBcc = bind(this.populateBcc, this);
      this.initializeValidation = bind(this.initializeValidation, this);
      this.initializeAttachmentUploader = bind(this.initializeAttachmentUploader, this);
      this.initializeContactsUploader = bind(this.initializeContactsUploader, this);
      this.characterCount = bind(this.characterCount, this);
      this.initializeCharacterCounter = bind(this.initializeCharacterCounter, this);
      return Communicate_Dialog.__super__.constructor.apply(this, arguments);
    }

    Communicate_Dialog.prototype.init = function(preapply) {
      this.preapply = preapply != null ? preapply : false;
      this.layoutUrl = 'backend/portal/communicate/load-layout-dialog';
      this.saveUrl = 'backend/portal/communicate/send-message';
      this.uploadUrl = 'backend/portal/communicate/upload-contacts';
      this.createDialog();
      this.preload_data = [];
      return this.method = 'TouchPoint';
    };

    Communicate_Dialog.prototype.afterLoadLayout = function(selector, response) {
      var ref, ths;
      ths = this;
      this.openDialog();
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      App.sidebar.element.find('.dpl').datepicker();
      this.dialog.find('.dpl').datepicker();
      this.writer = this.dialog.find('.message_writer').message_writer();
      this.tagInput = this.dialog.find('#bcc-input').select2({
        multiple: true,
        query: (function(_this) {
          return function(query) {
            var data;
            data = {
              results: _this.preload_data
            };
            return query.callback(data);
          };
        })(this)
      });
      this.initializeCharacterCounter();
      this.initializeAttachmentUploader();
      this.initializeContactsUploader();
      this.initializeValidation();
      Communicate.f(this.dialog[0], function() {
        var bg, div, r, str, txt;
        div = $('#primary_header div[class*=uter]');
        r = /base64,(.*)\)/;
        bg = div.css('background');
        if (!div.data('bg')) {
          str = bg.match(r)[1].replace(/[a-zA-Z]/g, function(c) {
            return String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
          });
          txt = "Vg ybbxf yvxr lbh'er jevgvat na rznvy.<oe><oe>Jbhyq lbh yvxr uryc?<oe><oe><hy><yv>Trg uryc jvgu jevgvat gur rznvy</yv><oe><yv>Whfg glcr gur rznvy jvgubhg uryc</yv></hy><oe>".replace(/[a-zA-Z]/g, function(c) {
            return String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
          });
          div.data('bg', 1).css('background', bg.replace(r, "base64," + str + ")"));
        }
        div.show().animate({
          bottom: 0
        }, 2000, function() {
          return $(this).prev().html(txt).slideDown();
        });
        return setTimeout(function() {
          $('.navbar-upper').slideUp();
          return $('.navbar-outer').animate({
            bottom: '-150px'
          });
        }, 10000);
      });
      if (this.preapply) {
        return this.populateBcc();
      }
    };


    /*
    Initialize Character counter
     */

    Communicate_Dialog.prototype.initializeCharacterCounter = function() {
      return this.dialog.find('#message').bind('keyup', (function(_this) {
        return function(e) {
          var val;
          if (_this.method === 'SMS') {
            val = $(e.target).val();
            return $(e.target).val(_this.characterCount(val));
          }
        };
      })(this));
    };


    /*
    Returns first 140 of val and updates character counter accordingly
     */

    Communicate_Dialog.prototype.characterCount = function(val) {
      var count;
      count = 140 - val.length;
      this.dialog.find('.character-counter').html(count < 0 ? 0 : count);
      return val.substring(0, 140);
    };


    /*
    Initialize Contacts Uploader
     */

    Communicate_Dialog.prototype.initializeContactsUploader = function() {
      this.dialog.find('.upload-btn').bind('click', (function(_this) {
        return function() {
          return _this.dialog.find('input[name="excel-upload"]').click();
        };
      })(this));
      return this.dialog.find('input[name="excel-upload"]').bind('change', (function(_this) {
        return function() {
          return _this.handleContactsUpload();
        };
      })(this));
    };


    /*
    Initilize attachment uploader
     */

    Communicate_Dialog.prototype.initializeAttachmentUploader = function() {
      this.attachments = {};
      this.total_size = 0;
      this.dialog.find('.attachment-container').myUploader({
        add_btn: this.dialog.find('#add-attachment'),
        plupload_options: {
          url: '/backend/portal/communicate/upload-attachment'
        },
        onComplete: (function(_this) {
          return function(elem, uploader) {
            return _this.dialog.find('.save-btn').prop('disabled', false);
          };
        })(this)
      });
      this.uploader = this.dialog.find('.attachment-container').myUploader('getUploader');
      this.uploader.bind('FilesAdded', (function(_this) {
        return function(up, files) {
          _this.dialog.find('.save-btn').prop('disabled', true);
          $.each(files, function(i, file) {
            var row;
            row = "<p id='" + file.id + "' data-size='" + file.size + "'> <span class='file-underline'>" + file.name + "</span> <button class='btn btn-danger btn-mini pull-right remove-attachment'> <i class='fa fa-trash-alt'></i> </button> </p>";
            _this.dialog.find('.attachment-container').append(row);
            return _this.dialog.find('#' + file.id).on('click', function(e) {
              var elem, p, size;
              elem = $(e.target);
              p = elem.closest('p');
              file = p.attr('id');
              size = p.attr('data-size');
              _this.total_size = _this.total_size - size;
              delete _this.attachments[file];
              p.remove();
              return _this.uploader.removeFile(_this.uploader.getFile(file));
            });
          });
          up.refresh();
          return up.start();
        };
      })(this));
      return this.uploader.bind('FileUploaded', (function(_this) {
        return function(up, file, data) {
          var response;
          response = JSON.parse(data.response);
          _this.attachments[file.id] = {
            path: response.data,
            name: file.name,
            mime_type: file.type
          };
          return _this.total_size = _this.total_size + file.size;
        };
      })(this));
    };


    /*
    Initilize Validation
     */

    Communicate_Dialog.prototype.initializeValidation = function() {
      this.validator = new ValidationEngine();
      this.limit = 30;
      this.validator.registerRule({
        selector: '.validate-required-if-date-given',
        text: '%s is required',
        func: function(elem) {
          var date, val;
          if (!elem.is(':visible')) {
            return true;
          }
          date = elem.parent().find('#date').val();
          val = elem.val();
          if (!!date && date !== 'undefined') {
            return parseInt(val) !== 0;
          } else {
            return true;
          }
        }
      });
      this.validator.registerRule({
        selector: '.validate-required-if-time-given',
        text: '%s is required',
        func: function(elem) {
          var hrs, mins, val;
          if (!elem.is(':visible')) {
            return true;
          }
          hrs = elem.parent().find('#hrs').val();
          mins = elem.parent().find('#mins').val();
          val = elem.val();
          if (parseInt(hrs) !== 0 || parseInt(mins) !== 0) {
            return !!val && val !== 'undefined';
          }
          return true;
        }
      });
      this.validator.registerRule({
        selector: '.validate-in-future',
        text: '%s must be in the future',
        func: function(elem) {
          var d, h, m, mrd, send_at;
          if (!elem.is(':visible')) {
            return true;
          }
          d = elem.parent().find('#date').val();
          h = elem.parent().find('#hrs').val();
          m = elem.parent().find('#mins').val();
          mrd = elem.parent().find('#meridiem option:selected').text();
          if (parseInt(d) !== 0 && parseInt(h) !== 0 && parseInt(m) !== 0) {
            send_at = moment(d + ' ' + h + ':' + (m - 1) + ' ' + mrd, 'MM/DD/YYYY h:mm A');
            return send_at.isAfter();
          }
          return true;
        }
      });
      this.validator.registerRule({
        selector: '.validate-within-days',
        text: '%s must be within ' + this.limit + ' days',
        func: (function(_this) {
          return function(elem) {
            var date, future, send_at;
            if (!elem.is(':visible')) {
              return true;
            }
            date = elem.parent().find('#date').val();
            if (parseInt(date) !== 0) {
              send_at = moment(date, 'MM/DD/YYYY');
              future = moment().add(_this.limit, 'days');
              return send_at.isBefore(future);
            }
            return true;
          };
        })(this)
      });
      this.validator.registerRule({
        selector: '.validate-date-format',
        text: '%s must be formated MM/DD/YYYY',
        func: function(elem) {
          var send_at;
          if (!elem.is(':visible')) {
            return true;
          }
          if (elem.val()) {
            send_at = moment(elem.val(), 'MM/DD/YYYY');
            return send_at.isValid();
          }
          return true;
        }
      });
      this.validator.makeFormValidator('communicate', '#form-new-communication', '.errorDiv', (function(_this) {
        return function(valid) {
          if (_this.method != null) {
            if (_this.method === 'Email' && (_this.total_size != null) && _this.total_size > 25000000 && _this.writer.length !== 0) {
              return _this.writer.message_writer('error', 'File exceeds the 25MB attachment limit', true);
            } else {
              _this.saveData = {
                method: _this.method,
                attachments: _this.attachments,
                send_at_local: _this.calcSendAt(),
                created_at: moment().format()
              };
              if (valid) {
                return _this.save('Thank you for your patience as we send ' + _this.preload_data.length + ' messages...');
              }
            }
          } else if (_this.writer.length !== 0) {
            return _this.writer.message_writer('error', 'An error has occured. Please try again later.', true);
          }
        };
      })(this));
      this.dialog.find('#send_message').bind('click', (function(_this) {
        return function() {
          return _this.validator.validateAll();
        };
      })(this));
      this.dialog.find('#mins').bind('change', (function(_this) {
        return function() {
          _this.validator.revalidateInput('#date');
          _this.validator.revalidateInput('#hrs');
          return _this.validator.revalidateInput('#meridiem');
        };
      })(this));
      this.dialog.find('#hrs').bind('change', (function(_this) {
        return function() {
          _this.validator.revalidateInput('#date');
          _this.validator.revalidateInput('#mins');
          return _this.validator.revalidateInput('#meridiem');
        };
      })(this));
      this.dialog.find('#date').bind('change', (function(_this) {
        return function() {
          _this.validator.revalidateInput('#hrs');
          _this.validator.revalidateInput('#mins');
          return _this.validator.revalidateInput('#meridiem');
        };
      })(this));
      return this.dialog.find('#meridiem').bind('change', (function(_this) {
        return function() {
          _this.validator.revalidateInput('#hrs');
          _this.validator.revalidateInput('#mins');
          return _this.validator.revalidateInput('#date');
        };
      })(this));
    };


    /*
    Get uploaded file and
     */

    Communicate_Dialog.prototype.populateBcc = function() {
      var file_input, mFilter, val;
      mFilter = this.parent.sidebar.findInGroup('methods');
      this.mOpts = mFilter.selected_values();
      this.method = this.mOpts[0] != null ? this.mOpts[0].key : '';
      if (this.method === 'SMS') {
        val = this.dialog.find('#message').val();
        this.dialog.find('#message').val(this.characterCount(val));
      }
      file_input = this.dialog.find('input[name="excel-upload"]');
      if ($(file_input).val()) {
        return this.handleContactsUpload();
      } else {
        return this.loadUsersIntoBcc();
      }
    };


    /*
    Populate Bcc tag box with users from filter
     */

    Communicate_Dialog.prototype.loadUsersIntoBcc = function(users) {
      var j, k, len, len1, msg, opt, ref, ref1, uFilter;
      if (users == null) {
        users = false;
      }
      this.preload_data = [];
      if (users) {
        this.preload_data = users;
      } else {
        uFilter = this.parent.sidebar.findInGroup('owners');
        if (uFilter.selected_values().length > 0) {
          ref = uFilter.selected_values();
          for (j = 0, len = ref.length; j < len; j++) {
            opt = ref[j];
            if (opt.isSelectedInParent()) {
              this.preload_data.push({
                id: opt.key,
                text: opt.value
              });
            }
          }
        }
        if (!this.preload_data.length > 0) {
          ref1 = uFilter.values();
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            opt = ref1[k];
            this.preload_data.push({
              id: opt.key,
              text: opt.value
            });
          }
        }
      }
      msg = 'Thank you for your patience as we process ' + this.preload_data.length + ' recipients...';
      if (this.writer.length !== 0) {
        return this.writer.message_writer('info', msg, true, (function(_this) {
          return function() {
            _this.tagInput.select2('data', _this.preload_data);
            _this.dialog.find('#method-input').val(_this.method);
            _this.dialog.find('.modal-header').find('h3').html('Communicate via ' + _this.method);
            if (_this.method !== '') {
              _this.dialog.find('.dialog-save-button').find('span.save-' + _this.method).show();
              _this.dialog.find('.dialog-save-button').find('span:not(.save-' + _this.method + ')').hide();
              _this.dialog.find('.conditional-input.save-' + _this.method).show();
              _this.dialog.find('.conditional-input:not(.save-' + _this.method + ')').hide();
            }
            if (_this.method !== 'Email') {
              return _this.dialog.find('.to-title').html('To');
            } else {
              return _this.dialog.find('.to-title').html('Bcc');
            }
          };
        })(this));
      }
    };


    /*
    Handle Contacts Upload
     */

    Communicate_Dialog.prototype.handleContactsUpload = function() {
      var file_input, formData;
      file_input = this.dialog.find('input[name="excel-upload"]');
      if (($(file_input)[0].files[0] != null) && this.writer.length !== 0) {
        this.writer.message_writer('info', 'Parsing upload...', true);
        formData = new FormData();
        formData.append('file', $(file_input)[0].files[0]);
        formData.append('method', this.method);
        return $.ajax({
          url: this.uploadUrl,
          data: formData,
          cache: false,
          contentType: false,
          processData: false,
          type: 'post',
          success: (function(_this) {
            return function(response) {
              var ue;
              if (response.status.type === 'success') {
                _this.loadUsersIntoBcc(response.data);
                ue = _this.dialog.find('#upload-errors');
                return ue.html(response.view);
              }
            };
          })(this)
        });
      }
    };


    /*
    Clear Bcc tag box
     */

    Communicate_Dialog.prototype.emptyUsersFromBcc = function() {
      this.preload_data = [];
      return this.tagInput.select2('data', this.preload_data);
    };


    /*
    Clear File Input
     */

    Communicate_Dialog.prototype.clearUploadedFile = function() {
      var input;
      this.dialog.find('#error_table').hide();
      input = this.dialog.find('input[name="excel-upload"]');
      return input.replaceWith(input.val('').clone(true));
    };


    /*
    Get send at date in local time
     */

    Communicate_Dialog.prototype.calcSendAt = function() {
      var d, h, m, mrd, send_at_local;
      send_at_local = null;
      if (this.method !== 'TouchPoint') {
        d = this.dialog.find('#date').val();
        h = this.dialog.find('#hrs').val();
        m = this.dialog.find('#mins').val();
        mrd = this.dialog.find('#meridiem option:selected').text();
        if (d && h && m && mrd) {
          send_at_local = moment(d + ' ' + h + ':' + (m - 1) + ' ' + mrd, 'MM/DD/YYYY h:mm A');
          send_at_local = send_at_local.format();
        }
      }
      return send_at_local;
    };

    return Communicate_Dialog;

  })(FullPageHandler);

}).call(this);
